import { render, staticRenderFns } from "./statusItem.vue?vue&type=template&id=1836120e"
import script from "./statusItem.vue?vue&type=script&lang=js"
export * from "./statusItem.vue?vue&type=script&lang=js"
import style0 from "./statusItem.vue?vue&type=style&index=0&id=1836120e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports